import session from './session'
import { rootAPI } from './settings'

const dashboardAPI = rootAPI && rootAPI.includes('localhost:5499')
  ? rootAPI.replace('localhost:5499', 'localhost:5020')
  : rootAPI

const isNotFound = error => error && error.response && error.response.status === 404
const isServerError = error => error && error.response && error.response.status >= 500

const fetchApiCredentials = () => {
  return session.get(rootAPI + 'settings/api-credentials')
}

const getSettings = params => {
  return session.post(rootAPI + 'settings/get', params)
}

const saveSettings = (params, settingsType) => {
  return session.post(rootAPI + 'settings/save/' + settingsType, params)
}

const getCampaignFrequencyCapping = payload => {
  return session.get(rootAPI + 'settings/get/campaign-frequency-capping', payload)
}

const saveCampaignFrequencyCapping = payload => {
  return session.post(rootAPI + 'settings/save/campaign-frequency-capping', payload)
}

// Get campaign throttling settings
const getCampaignThrottling = payload => {
  return session.get(rootAPI + 'settings/get/campaign-throttling', payload)
}

// Save campaign throttling settings
const saveCampaignThrottling = payload => {
  return session.post(rootAPI + 'settings/save/campaign-throttling', payload)
}

const getDoNotDisturb = (keys) => {
  return session.get(`${rootAPI}settings/get/${keys}`)
}

// Save do not disturb settings
const saveDoNotDisturb = payload => {
  return session.post(rootAPI + 'settings/save/campaign-dnd', payload)
}

// Save custom domain list.
const saveCustomDomainList = domainList => {
  return session.post(rootAPI + 'settings/save/campaign-tracking-custom-domain-list', domainList)
}

// Save Default custom domain.
const saveDefaultCustomDomain = domain => {
  return session.post(rootAPI + 'settings/save/campaign-tracking-custom-domain', domain)
}

const validateEmailSenderDomainConfig = domain => {
  return session.post(rootAPI + 'settings/validate-custom-domain', { domain: domain })
}

const getEventMetadata = async () => {
  try {
    return await session.get(rootAPI + 'settings/event-metadata')
  } catch (error) {
    if ((isNotFound(error) || isServerError(error)) && dashboardAPI !== rootAPI) {
      return session.get(dashboardAPI + 'event/metadata')
    }
    throw error
  }
}

const getDefaultEventSettings = async eventType => {
  try {
    return await session.get(rootAPI + 'settings/default-events/' + eventType)
  } catch (error) {
    if (isNotFound(error) && dashboardAPI !== rootAPI) {
      return session.get(dashboardAPI + 'settings/default-events/' + eventType)
    }
    throw error
  }
}

const saveDefaultEventSettings = async payload => {
  try {
    return await session.post(rootAPI + 'settings/default-events', payload)
  } catch (error) {
    if (isNotFound(error) && dashboardAPI !== rootAPI) {
      return session.post(dashboardAPI + 'settings/default-events', payload)
    }
    throw error
  }
}

export {
  fetchApiCredentials,
  getSettings,
  saveSettings,
  getCampaignFrequencyCapping,
  saveCampaignFrequencyCapping,
  getCampaignThrottling,
  saveCampaignThrottling,
  getDoNotDisturb,
  saveDoNotDisturb,
  saveCustomDomainList,
  saveDefaultCustomDomain,
  validateEmailSenderDomainConfig,
  getEventMetadata,
  getDefaultEventSettings,
  saveDefaultEventSettings
}
